import useCommandFlowStore from "../../store/commandFlowStore";

// Handles appending user input to output
export function handleAppendInputToOutput({ currentPrompt, trimmed, setters }) {
  const setOutput = useCommandFlowStore.getState().setOutput;

  if (currentPrompt) {
    const promptEndsWithNewline = currentPrompt.trim().endsWith("\n");
    if (promptEndsWithNewline) {
      setOutput((prev) => [
        ...prev,
        { type: "input", text: currentPrompt.trimEnd() },
        { type: "input", text: trimmed },
      ]);
    } else {
      setOutput((prev) => [
        ...prev,
        {
          type: "output",
          text: [
            { text: currentPrompt, color: "output" },
            { text: " ", color: null },
            { text: trimmed, color: "input" },
          ],
        },
      ]);
    }
  } else {
    setOutput((prev) => [...prev, { type: "input", text: trimmed }]);
  }
}
